/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AccountDetails from '../UserSetting/AccountDetails';
import Factories from '../UserSetting/Factories/Factories';

function NonSupplierFactory(props) {
  const { search } = useLocation();
  const [activeTab, setActiveTab] = useState('accountDetails'); // Default active tab
  const queryParams = new URLSearchParams(search);
  const querySupplierId = queryParams.get('supplierId');
  const { t } = useTranslation('common');

  const supplierid = querySupplierId;

  const { navRefs, vlinksRefs } = props;

  const navigateToTab = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <div className="sub-navigation">
        <div className="sub-navigation">
          <nav className="greedy-nav" ref={navRefs}>
            <ul className="subnav-ul visible-links" ref={vlinksRefs}>
              <li>
                <button
                  type="button"
                  className={`cursor-pointer text-decoration-none btn-subnav ${activeTab === 'accountDetails' ? 'active' : ''}`}
                  onClick={() => navigateToTab('accountDetails')}
                >
                  <i className="icon-account-details" />
                  <span>{t('NON_SUPPLIER.NON_SUPLIER_FACTORY.ACCOUNT_DETAILS')}</span>
                </button>
              </li>

              <li>
                <button
                  type="button"
                  className={`cursor-pointer text-decoration-none btn-subnav ${activeTab === 'factories' ? 'active' : ''}`}
                  onClick={() => navigateToTab('factories')}
                >
                  <i className="icon-user-management" />
                  <span>{t('NON_SUPPLIER.NON_SUPLIER_FACTORY.FACTORIES')}</span>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div>{activeTab === 'accountDetails' ? <AccountDetails /> : <Factories querySupplierId={supplierid} />}</div>
    </>
  );
}

export default NonSupplierFactory;
